module.exports = __webpack_public_path__ + "60c823a3b3ac4661d81e7c4e276cc031.png";